import { useEffect } from "react";

const STYLE_ID = "google-translate-hide";

/**
 * Global Google Translate host.
 * Must stay mounted across route changes, otherwise Google Translate can break the DOM / show the banner again.
 */
export default function GoogleTranslateGlobal() {
  useEffect(() => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.innerHTML = `
      /* Hide ALL Google Translate UI elements */
      .goog-te-banner-frame,
      .goog-te-balloon-frame,
      #goog-gt-tt,
      .goog-tooltip,
      .goog-tooltip:hover,
      .goog-te-gadget,
      .goog-te-spinner-pos,
      #goog-gt-vt,
      .goog-te-ftab-link,
      .goog-te-menu-value,
      .goog-te-menu-frame,
      .goog-logo-link,
      /* New Google Translate UI classes */
      .VIpgJd-ZVi9od-l4eHX-hSRGPd,
      .VIpgJd-ZVi9od-ORHb-OEVmcd,
      .VIpgJd-ZVi9od-aZ2wEe-wOHMyf,
      .VIpgJd-ZVi9od-aZ2wEe-OiiCO,
      .VIpgJd-ZVi9od-xl07Ob-lTBxed,
      .VIpgJd-ZVi9od-SmfZ-xl07Ob,
      .VIpgJd-suEOdc,
      div[id^="goog-gt"],
      iframe[id^="goog-gt"],
      .skiptranslate,
      [class*="VIpgJd"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        width: 0 !important;
        max-height: 0 !important;
        max-width: 0 !important;
        overflow: hidden !important;
        pointer-events: none !important;
      }

      /* Force hide the top banner frame */
      body > .skiptranslate {
        display: none !important;
      }

      /* Prevent layout shifts Google injects */
      body,
      body.translated-ltr,
      body.translated-rtl {
        top: 0 !important;
        position: static !important;
        background-color: hsl(var(--background)) !important;
        min-height: 100vh !important;
        margin-top: 0 !important;
        padding-top: 0 !important;
      }

      html,
      html.translated-ltr,
      html.translated-rtl {
        background-color: hsl(var(--background)) !important;
        margin-top: 0 !important;
        padding-top: 0 !important;
      }

      .translated-ltr,
      .translated-rtl {
        margin-top: 0 !important;
      }

      /* Ensure root element has correct background */
      #root {
        background-color: hsl(var(--background)) !important;
        min-height: 100vh !important;
      }
    `;

    document.head.appendChild(style);
  }, []);

  // Keep this element mounted across route changes.
  return <div id="google_translate_element" className="hidden" />;
}
